import React from 'react';
import { Modal, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PlanEditor from './PlanEditor';

/**
 * PlanModal Component - Modal wrapper for plan editing
 * Provides full-screen modal experience for plan editing
 */
const PlanModal = ({ open, onClose, planKey }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      width="100vw"
      style={{ 
        top: 0,
        padding: 0,
        maxWidth: '100vw'
      }}
      bodyStyle={{
        padding: 0,
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}
      footer={null}
      closable={false}
      destroyOnClose
    >
      {/* Close button */}
      <Button
        icon={<CloseOutlined />}
        onClick={onClose}
        style={{
          position: 'absolute',
          right: 16,
          top: 16,
          zIndex: 1000,
          backgroundColor: 'white',
          border: '1px solid #d9d9d9',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}
        shape="circle"
      />
      
      {/* Plan Editor */}
      {planKey && (
        <PlanEditor 
          planKey={planKey} 
          onClose={onClose}
        />
      )}
    </Modal>
  );
};

export default PlanModal;
